import { createBaseQueryWithReauth } from "@cointervue/shared/api";
import { BANK, BANK_ROUTES, HTTP_METHODS } from "@cointervue/shared/constants";
import { createApi } from "@reduxjs/toolkit/query/react";
import type {
  QuestionsApiResponse,
  QuestionApiRequest,
  SkillsApiResponse,
  SkillsApiRequest,
  AddSkillApiRequest,
  AddSkillApiResponse,
  AddQuestionApiResponse,
  AddQuestionApiRequest,
} from "./types";
import { logout } from "../../store/authSlice";

export const questionsSkillsBankApi = createApi({
  reducerPath: "questionsSkillsBankApi",
  baseQuery: createBaseQueryWithReauth(BANK.href, logout),
  tagTypes: ["Questions", "Skills"],
  endpoints: (builder) => ({
    getQuestionsByType: builder.query<QuestionsApiResponse, QuestionApiRequest>(
      {
        query: ({ type, s, level }) => ({
          url: `${BANK_ROUTES.questionsByType}${type}`,
          method: HTTP_METHODS.GET,
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
          params: {
            ...(s && { s }),
            ...(level && { level }),
          },
        }),
        providesTags: (_res, _err, { type }) => [
          { type: "Questions", id: type },
          { type: "Questions", id: "LIST" },
        ],
      },
    ),
    addQuestion: builder.mutation<
      AddQuestionApiResponse,
      AddQuestionApiRequest
    >({
      query: (body) => ({
        url: BANK_ROUTES.addQuestion,
        method: HTTP_METHODS.POST,
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body,
      }),
      invalidatesTags: [{ type: "Questions", id: "LIST" }],
    }),

    getSkill: builder.query<SkillsApiResponse, SkillsApiRequest>({
      query: ({ s }) => {
        const params: Record<string, string> = {};
        if (s) params.s = s;
        return {
          url: BANK_ROUTES.skill,
          method: HTTP_METHODS.GET,
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
          params: Object.keys(params).length > 0 ? params : undefined,
        };
      },
      providesTags: [{ type: "Skills", id: "LIST" }],
    }),

    addSkill: builder.mutation<AddSkillApiResponse, AddSkillApiRequest>({
      query: (body) => ({
        url: BANK_ROUTES.skill,
        method: HTTP_METHODS.POST,
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body,
      }),
      invalidatesTags: [{ type: "Skills", id: "LIST" }],
    }),
  }),
});

export const {
  useGetQuestionsByTypeQuery,
  useGetSkillQuery,
  useAddSkillMutation,
  useAddQuestionMutation,
} = questionsSkillsBankApi;
